<template>
    <v-app>
        <v-main>
            <v-container>
                <v-card>
                    <v-card-title>
                        Hall of Fame groups list
                    </v-card-title>
                    <v-data-table :items="groups" :headers="headers">
                        <template v-slot:item.pages="{ item }">
                            {{ item.pages.map(x => x.name).join(', ') }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="openUpdateDialog(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                @click="openDeleteDialog(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="openCreateDialog()">
                            Create
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
            <v-dialog v-model="createDialog" max-width="600px">
                <hall-of-fame-edit-form
                    :pages="pages"
                    :visible="createDialog"
                    @submit="createGroup"
                    @close="createDialog = false"
                />
            </v-dialog>
            <v-dialog v-model="updateDialog" max-width="600px">
                <hall-of-fame-edit-form
                    :currentGroup="editGroup"
                    :pages="pages"
                    :visible="updateDialog"
                    @submit="updateGroup"
                    @close="updateDialog = false"
                />
            </v-dialog>
            <v-dialog v-model="deleteDialog" max-width="400px">
                <hall-of-fame-delete-dialog
                    :group="editGroup"
                    @submit="deleteGroup"
                    @close="deleteDialog = false"
                />
            </v-dialog>
        </v-main>
    </v-app>
</template>
<script>
import hallOfFameEditForm from './hallOfFameEditForm';
import hallOfFameDeleteDialog from './hallOfFameDeleteDialog';

export default {
    components: {
        hallOfFameEditForm,
        hallOfFameDeleteDialog,
    },

    props: {
        pages: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            groups: [],
            createDialog: false,
            updateDialog: false,
            deleteDialog: false,
            headers: [
                { text: "Name", value: "name" },
                { text: "Slug", value: "slug" },
                { text: "Pages", value: "pages" },
                { text: "Actions", value: "actions" },
            ],
            editGroup: {},
        }
    },

    created() {
        this.getGroups();
    },

    methods: {
        getGroups() {
            axios.get('/api/developer/hall-of-fame/groups')
                .then(response => {
                    this.groups = response.data;
                })
        },

        openCreateDialog() {
            this.editGroup = {};
            this.createDialog = true;
        },

        openUpdateDialog(group) {
            this.editGroup = group;
            this.updateDialog = true;
        },

        openDeleteDialog(group) {
            this.editGroup = group;
            this.deleteDialog = true;
        },

        createGroup(group, newLogoImage) {
            let data = new FormData();
            data.append('name', group.name);
            data.append('slug', group.slug);
            group.page_ids.forEach(page_id => {
                data.append('page_ids[]', page_id);
            });
            if (newLogoImage) {
                data.append('logo', newLogoImage);
            }
            axios.post('/api/developer/hall-of-fame/groups', data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(() => {
                    this.getGroups();
                })
                .finally(() => {
                    this.createDialog = false;
                });
        },

        updateGroup(group, newLogoImage) {
            let data = new FormData();
            data.append('name', group.name);
            data.append('slug', group.slug);
            group.page_ids.forEach(page_id => {
                data.append('page_ids[]', page_id);
            });
            if (newLogoImage) {
                data.append('logo', newLogoImage);
            }
            data.append('_method', 'PUT');
            axios.post('/api/developer/hall-of-fame/groups/' + group.id, data)
                .then(() => {
                    this.getGroups();
                })
                .finally(() => {
                    this.updateDialog = false;
                });
        },

        deleteGroup(event, group) {
            axios.delete('/api/developer/hall-of-fame/groups/' + group.id)
                .then(() => {
                    this.getGroups();
                })
                .finally(() => {
                    this.deleteDialog = false;
                });
        },
    },
};
</script>
